module.exports = __webpack_public_path__ + "helvetica_neu_bold-webfont.d0d96ad41dfa50bb801b.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helvetica_neu_bold-webfont.ttf
// module id = ../../../../../src/assets/fonts/helvetica_neu_bold-webfont.ttf
// module chunks = styles